// Custom color definitions
export const customColors = {
    gray: {
        950: "#111418",
        900: "#1C222D",
        800: "#2A3241",
        700: "#364153",
        600: "#545D6C",
        500: "#7B818D",
        400: "#969CA5",
        300: "#B2B6BD",
        200: "#D3D5D9",
        150: "#DFE0E2",
        100: "#EEEEEF",
        50: "#F7F7F7",
    },
    golden: {
        950: "#331606",
        900: "#713912",
        800: "#B76020",
        700: "#E38122",
        600: "#F09517",
        500: "#FFAA0D",
        400: "#FFBE2C",
        300: "#FFD046",
        200: "#FFE262",
        100: "#FFEFA8",
        50: "#FFFAE0",
    },
    blue: {
        950: "#041728",
        900: "#07355F",
        800: "#085092",
        700: "#0A6CC6",
        600: "#137FE3",
        500: "#1C91FF",
        400: "#4BABFF",
        300: "#7AC6FF",
        200: "#9FDBFF",
        100: "#CAEBFF",
        50: "#E9F7FF",
    },
    green: {
        950: "#04140A",
        900: "#0A361A",
        800: "#105B2B",
        700: "#277644",
        600: "#418B5C",
        500: "#6AA668",
        400: "#91C174",
        300: "#BCDE81",
        200: "#E2F78C",
        100: "#F0FBBD",
        50: "#FEFFF0",
    },
    rose: {
        950: "#220A04",
        900: "#571609",
        800: "#8C230D",
        700: "#B22E13",
        600: "#C93913",
        500: "#E14322",
        400: "#ED756C",
        300: "#F8A6B4",
        200: "#FFC3DF",
        100: "#FFDCEC",
        50: "#FFF1F7",
    },
};
//# sourceMappingURL=colors.js.map